import { HEADERS } from './fixtures';
import React from 'react';
import { StatisticsLayout } from 'views/components';
import { Table } from 'mol-ui';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    useDispatch,
    useSelector
} from 'hooks';

const StatisticsSymptoms = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        loading,
        symptoms
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsSymptoms(filters));
    };

    return (
        <StatisticsLayout
            loading={ loading }
            title={ t('Síntomas') }
            onFiltersChange={ onFiltersChange }
        >
            <Table
                config={ HEADERS }
                data={ symptoms }
            />
        </StatisticsLayout>
    );
};

export default StatisticsSymptoms;
